<template>
  <div class="w-full flex flex-row justify-center bg-themeComponentBg-light service-area-text-outer-container">
    <div class="flex flex-col gap-7 w-full max-w-1216 pt-3 mx-5 font-rubik">
      <h3 class="service-area-h2 text-center" v-html="heading"></h3>
      <div v-html="contentHtml" class="service-area-p"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      default: ''
    },
    contentHtml: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.service-area-text-outer-container {
  padding-top: 112px;  
}
.service-area-h2 {
  color: #334155;
  font-size: 48px !important;
  font-weight: 400;
  line-height: 57.6px;
  letter-spacing: -0.04em;
}
.service-area-p {
  color: #334155;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
}
/* mobile */
@media(max-width: 1024px) {
  .service-area-text-outer-container {
    padding-top: 24px;  
  }
  .service-area-h2 {
    font-size: 24px;
    font-weight: 400;
    line-height: 28.8px;
    letter-spacing: -0.04em;
  }
  .service-area-p {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
  }
}
</style>